import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { useMCAPSCopilotTelemetry } from '../../utils/mcapsCopilotTelemetry';
import changeTopicWhite from '../../assets/change-topic-white.svg';
import changeTopicBlack from '../../assets/change-topic-black.svg';
import type { NewConversationProps } from '../../interfaces';

const useStyles = makeStyles({  
  changeTopicOuter: {
    alignItems: "center",
    textAlign: "center", 
    margin: "10px",
    display: "flex",
    justifyContent: "center",
  },
  changeTopicInner: {
    alignItems: "center",
    display: "flex",
    cursor: "pointer",
    width: "fit-content",
  },
  spanText: { 
    marginLeft: "10px" 
  },
  imageIcon: { 
    width: "20px", 
    height: "20px" 
  },
});

const NewConversation: React.FC<NewConversationProps> = ({
  show = true,
  onNewConversation,
  text = 'New conversation',
  theme = 'light',
  className = '',
  dispatch
}) => {
  const styles = useStyles();
  const telemetry = useMCAPSCopilotTelemetry(dispatch);
  
  const handleClick = () => {
    
    telemetry.logNewConversationAction({
      action: 'click',
      component: 'NewConversation'
    });

    if (onNewConversation) {
      onNewConversation();
    }
  };

  
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();      
      
      telemetry.logNewConversationAction({
        action: 'click',
        component: 'NewConversation'
      });
      if (onNewConversation) {
        onNewConversation();
      }
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className={`${styles.changeTopicOuter} ${className}`}>
      <div className={styles.changeTopicOuter}>
        <div
          className={styles.changeTopicInner}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role="button"
          aria-label={text}
        >
          <img
            src={theme === "dark" ? changeTopicWhite : changeTopicBlack}
            alt="Icon Image"
            className={styles.imageIcon}
          />
          {" "}
          <span className={styles.spanText}>{text}</span>
        </div>
      </div>
    </div>
  );
};

export default NewConversation;